import { render, staticRenderFns } from "./PurchasePatentContent.vue?vue&type=template&id=778d85eb&scoped=true"
import script from "./PurchasePatentContent.vue?vue&type=script&lang=js"
export * from "./PurchasePatentContent.vue?vue&type=script&lang=js"
import style0 from "./PurchasePatentContent.vue?vue&type=style&index=0&id=778d85eb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778d85eb",
  null
  
)

export default component.exports